import React, { useState, useEffect } from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import api from '../api';

export default function Reports() {
  const [tab, setTab] = useState('brands');
  const [brandData, setBrandData] = useState([]);
  const [trendData, setTrendData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [brands, trends] = await Promise.all([
          api.salesByBrand(),
          api.trends(),
        ]);
        setBrandData(brands || []);
        setTrendData(trends || []);
      } catch (err) { console.error(err); }
      setLoading(false);
    };
    load();
  }, []);

  if (loading) return <div className="loading-spinner"><div className="spinner" /></div>;

  return (
    <div>
      <div className="tab-buttons" data-testid="reports-tabs">
        <button className={`tab-btn ${tab === 'brands' ? 'active' : ''}`} onClick={() => setTab('brands')}>Por Marca</button>
        <button className={`tab-btn ${tab === 'trends' ? 'active' : ''}`} onClick={() => setTab('trends')}>Tendencias</button>
      </div>

      {tab === 'brands' && (
        <div>
          <div className="section-card" data-testid="reports-brand-chart">
            <h3>Ventas totales por marca</h3>
            <div style={{marginTop:'16px'}}>
              <ResponsiveContainer width="100%" height={350}>
                <BarChart data={brandData} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" stroke="hsl(214,18%,88%)" />
                  <XAxis type="number" tick={{fontSize:11}} />
                  <YAxis type="category" dataKey="brand" tick={{fontSize:11}} width={100} />
                  <Tooltip contentStyle={{fontSize:'0.78rem',borderRadius:'8px',border:'1px solid hsl(214,18%,88%)'}} />
                  <Bar dataKey="total" fill="hsl(199,84%,38%)" radius={[0,4,4,0]} name="Unidades vendidas" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="data-table-container" style={{marginTop:'20px'}}>
            <div className="data-table-header"><h3>Detalle por marca</h3></div>
            <table className="data-table">
              <thead><tr><th>Marca</th><th className="right">Total vendido</th><th className="right">Meses con datos</th></tr></thead>
              <tbody>
                {brandData.map(b => (
                  <tr key={b.brand}>
                    <td style={{fontWeight:500}}>{b.brand}</td>
                    <td className="right mono">{b.total?.toLocaleString()}</td>
                    <td className="right mono">{b.monthly?.length || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'trends' && (
        <div className="section-card" data-testid="reports-trends-chart">
          <h3>Tendencia de ventas mensuales</h3>
          <div style={{marginTop:'16px'}}>
            <ResponsiveContainer width="100%" height={350}>
              <LineChart data={trendData}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(214,18%,88%)" />
                <XAxis dataKey="month" tick={{fontSize:10}} angle={-30} textAnchor="end" height={50} />
                <YAxis tick={{fontSize:11}} />
                <Tooltip contentStyle={{fontSize:'0.78rem',borderRadius:'8px',border:'1px solid hsl(214,18%,88%)'}} />
                <Legend />
                <Line type="monotone" dataKey="total" stroke="hsl(199,84%,38%)" strokeWidth={2} dot={{r:3}} name="Unidades" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </div>
  );
}
